// SoClose Pte. Ltd. - Singapore legal & branding constants
// Use this everywhere instead of hardcoding company info.
export const SOCLOSE = {
  name: 'SoClose Pte. Ltd.',
  shortName: 'SoClose',
  uen: '202555665W',
  uenLabel: 'UEN 202555665W',
  registrationDate: '2025-12-16',
  legalForm: 'Exempt Private Company Limited by Shares',
  jurisdiction: 'Singapore',
  jurisdictionFlag: 'SG',
  address: {
    line1: 'Suntec Tower One',
    line2: '7 Temasek Boulevard, #12-007',
    postal: '038987',
    city: 'Singapore',
    country: 'Singapore',
    full: 'Suntec Tower One, 7 Temasek Boulevard, #12-007, Singapore 038987',
  },
  contact: {
    email: 'contact@soclose.co',
    phone: '+66 64 027 21 21',
    phoneRaw: '+66640272121',
    website: 'https://soclose.co',
  },
  business: {
    primary: 'Development of software and applications',
    secondary: 'Advertising activities',
  },
  // PDPA = Personal Data Protection Act (Singapore equivalent of GDPR)
  privacy: {
    framework: 'PDPA',
    frameworkFull: 'Singapore Personal Data Protection Act 2012 (PDPA)',
    authority: 'Personal Data Protection Commission (PDPC)',
    authorityUrl: 'https://www.pdpc.gov.sg/',
  },
  // Pricing & currency
  currency: {
    code: 'SGD',
    symbol: 'S$',
    name: 'Singapore Dollar',
  },
};

export const SOCLOSE_FX = {
  EUR_TO_SGD: 1.42,
  USD_TO_SGD: 1.30,
  THB_TO_SGD: 0.038,
};

// Format a SGD price for display.
//   formatSGD(29) => "S$ 29"
//   formatSGD(29.5) => "S$ 29.50"
export function formatSGD(amount, { round = true, currency = 'SGD' } = {}) {
  const symbol = SOCLOSE.currency.symbol;
  if (round) {
    const rounded = Math.round(amount);
    return `${symbol} ${rounded.toLocaleString('en-SG')}`;
  }
  return `${symbol} ${amount.toLocaleString('en-SG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

// Convert from EUR/USD/THB to SGD using fixed rates.
//   toSGD(20, 'EUR') => 28.4   (20 * 1.42)
//   toSGD(15, 'USD') => 19.5   (15 * 1.30)
export function toSGD(amount, fromCurrency = 'EUR') {
  const key = `${fromCurrency.toUpperCase()}_TO_SGD`;
  const rate = SOCLOSE_FX[key];
  if (!rate) {
    console.warn(`No FX rate for ${fromCurrency}, returning amount as-is`);
    return amount;
  }
  return amount * rate;
}

// One-step: convert + format. Used everywhere you have legacy EUR/USD prices.
//   priceInSGD(19, 'EUR') => "S$ 27"
export function priceInSGD(amount, fromCurrency = 'EUR', opts) {
  return formatSGD(toSGD(amount, fromCurrency), opts);
}
